import { GlobalSite } from "types/CMS/KontentAI/content-types/site";

import { globalSite } from "types/CMS/Unum/GlobalSite/globalSite";
import { primaryNavigationReslover } from "./primaryNavigation";
import { KontentFilterInputs } from "types/CMS/Unum/filterable";
import { logExceptionToInsights } from "../../../../../ApplicationInsights";

export const globalSiteResolver = (
  site: GlobalSite[],
  filters: KontentFilterInputs,
): globalSite | undefined => {
  if (!site || site.length === 0) {
    return undefined;
  }
  const currentSite = site[0];
  try {
    return {
      type: "site",
      primaryNavigation: primaryNavigationReslover.resolve(
        currentSite.elements.primary_navigation.linkedItems,
        filters,
      ).result,
    };
  } catch (e) {
    logExceptionToInsights("globalSiteResolver", e);
    return undefined;
  }
};
  